import React, { Component } from 'react';

import Constants from '../Constants';

import '../styles/Footer.css';

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <div className="footer-main">
          <div className="footer-text">
            v{Constants.VERSION} · {Constants.VERSION_DATE} · Written by <a href="https://maxwoghiren.com">Max Woghiren</a> · <button
              type="button"
              className="footer-feedback"
              onClick={this.props.onFeedbackClick}
            >
              Leave Feedback
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
